module.exports = "pegasus/assets/blocks/image-3-basic.png";